import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {get, orderBy} from 'lodash';
import * as asyncActionCreator from '../../../redux/actionCreators/async';
import {updateAlerts} from '../../../redux/actionCreators/sync';
import * as contactApi from '../../../redux/actionCreators/async/contacts';
import UserAlert from './UserAlert';
import JobRequestAlert from './JobRequestAlert';
import UserAlertDetail from './UserAlertDetail';
import JobRequestAlertDetail from './JobRequestAlertDetail';

@connect((store) => ({user: store.user, alerts: store.alerts, staticData: store.staticData}))
export default class AlertsDashboard extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    alerts: PropTypes.object,
  }

  constructor(props, context) {
    super(props, context);
    this.selectUserAlert = ::this.selectUserAlert;
    this.selectJobRequestAlert = ::this.selectJobRequestAlert;

  }

  state = {
    selectedData: false,
    selectedAlert: null,
  }

  loadAlerts() {
    // check current alerts
    this.props.dispatch(asyncActionCreator.getAlerts({
        success: (data) => {
          this.props.dispatch(updateAlerts(data.items));
        }
      }));
  }

  dismissNotification = (event, alertId) => {
    this.props.dispatch(asyncActionCreator.deleteAlert(alertId, {
        success: () => this.loadAlerts()
      }));
    event.stopPropagation();
  }

  selectUserAlert(alert) {

    this.props.dispatch(contactApi.getContact(alert.alertData.target, (err, data) => {
        if (!err && data) {
          this.setState({selectedAlert: alert, selectedData: data.contact});
        }
      }));

    this.markAsRead(alert);

  }

  selectJobRequestAlert(alert) {

    this.props.dispatch(contactApi.getContact(alert.alertData.target, (err, data) => {
      if (!err && data) {
        this.setState({selectedAlert: alert, selectedData: data.contact});
      }
    }));

    this.markAsRead(alert);

  }

  markAsRead(alert) {
    if (!alert.isRead) {
      // set alert to read state
      this.props.dispatch(asyncActionCreator.readAlert(alert.id, {
          success: () => this.loadAlerts()
        }));
      }
  }

  render() {

    function displayAlertDetailComponent(state) {
      switch(state.selectedAlert.alertData.type) {

          case 'JobRequestAlert':
            return (<JobRequestAlertDetail detail={state.selectedData} />);

          case 'UserAlert':
          default:
            return (<UserAlertDetail detail={state.selectedData} />);

      }
    }
    const alerts = orderBy(this.props.alerts, ['dateCreated'], ['desc']);
    return (
      <div className='alerts-dashboard content-container'>
          <h1>All Notifications & Alerts History</h1>
          <div className='alerts-list-detail-container'>
            <div className='alerts-list'>

              {Object
                .keys(alerts)
                .map((alertKey) => {

                  const alert = this.props.alerts[alertKey];
                  switch(alert.alertData.type) {

                    case 'JobRequestAlert':
                      return (<JobRequestAlert
                        selected={get(this.state, 'selectedAlert.id', null)}
                        dispatch={this.props.dispatch}
                        alert={alert}
                        onSelect={this.selectJobRequestAlert}
                        onClose={this.dismissNotification} />
                      );

                    case 'UserAlert':
                    default:
                      return (
                        <UserAlert
                          selected={get(this.state, 'selectedAlert.id', null)}
                          dispatch={this.props.dispatch}
                          alert={alert}
                          onSelect={this.selectUserAlert}
                          onClose={this.dismissNotification} />
                        );

                    }

                  })}

            </div>
            <div className='alert-detail'>
              { this.state.selectedData &&  displayAlertDetailComponent(this.state) }
            </div>
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Alerts/index.js